export const VERSION = '5.0.2'; // x-release-please-version
